/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthSectionIndexRouteImport } from './routes/_auth.$section/index'
import { Route as AuthSectionIdRouteImport } from './routes/_auth.$section/$id'

const AuthIndexLazyRouteImport = createFileRoute('/_auth/')()

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexLazyRoute = AuthIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth.index.lazy').then((d) => d.Route))
const AuthSectionIndexRoute = AuthSectionIndexRouteImport.update({
  id: '/$section/',
  path: '/$section/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSectionIdRoute = AuthSectionIdRouteImport.update({
  id: '/$section/$id',
  path: '/$section/$id',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/unauthorized': typeof UnauthorizedRoute
  '/': typeof AuthIndexLazyRoute
  '/$section/$id': typeof AuthSectionIdRoute
  '/$section': typeof AuthSectionIndexRoute
}
export interface FileRoutesByTo {
  '/unauthorized': typeof UnauthorizedRoute
  '/': typeof AuthIndexLazyRoute
  '/$section/$id': typeof AuthSectionIdRoute
  '/$section': typeof AuthSectionIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/unauthorized': typeof UnauthorizedRoute
  '/_auth/': typeof AuthIndexLazyRoute
  '/_auth/$section/$id': typeof AuthSectionIdRoute
  '/_auth/$section/': typeof AuthSectionIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/unauthorized' | '/' | '/$section/$id' | '/$section'
  fileRoutesByTo: FileRoutesByTo
  to: '/unauthorized' | '/' | '/$section/$id' | '/$section'
  id:
    | '__root__'
    | '/_auth'
    | '/unauthorized'
    | '/_auth/'
    | '/_auth/$section/$id'
    | '/_auth/$section/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/$section/': {
      id: '/_auth/$section/'
      path: '/$section'
      fullPath: '/$section'
      preLoaderRoute: typeof AuthSectionIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/$section/$id': {
      id: '/_auth/$section/$id'
      path: '/$section/$id'
      fullPath: '/$section/$id'
      preLoaderRoute: typeof AuthSectionIdRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthIndexLazyRoute: typeof AuthIndexLazyRoute
  AuthSectionIdRoute: typeof AuthSectionIdRoute
  AuthSectionIndexRoute: typeof AuthSectionIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthIndexLazyRoute: AuthIndexLazyRoute,
  AuthSectionIdRoute: AuthSectionIdRoute,
  AuthSectionIndexRoute: AuthSectionIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
